import type { Profile } from '@gobingebox/shared';
import { cn } from '@/lib/cn';

export function ProfileAvatar({
  profile,
  size = 64,
  className,
}: {
  profile: Pick<Profile, 'name' | 'avatarColor' | 'isKids'>;
  size?: number;
  className?: string;
}) {
  return (
    <span
      style={{ backgroundColor: profile.avatarColor, width: size, height: size }}
      className={cn('grid shrink-0 place-items-center rounded-xl font-display font-bold leading-none text-white', className)}
      aria-hidden
    >
      <span style={{ fontSize: Math.round(size * 0.4) }}>{(profile.name || '?').charAt(0).toUpperCase()}</span>
    </span>
  );
}
